<template>

 
  <ul class="navbar-nav mb-2 mb-lg-0">
 
    <li
        :class="menu.items && menu.items.length > 0 ? 'nav-item dropdown' : 'nav-item '"
        v-for="(menu, x) in menus"
        :key="x" >
      <router-link
        v-if="menu.items && menu.items.length > 0"
        to="#"
        :id="'navbarDropdown_' + x"
        role="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        class="nav-link dropdown-toggle">
        {{ $helpers.getLocalizedField(menu, 'name') }}
      </router-link>
      <router-link v-else to="" class="nav-link">
        {{ $helpers.getLocalizedField(menu, 'name')}}
      </router-link>
      <!-- Dropdown links list start -->
      <ul
        v-if="menu.items && menu.items.length > 0"
        class="dropdown-menu"
        :id="'dropdown-menu-'+x"
        :aria-labelledby="'navbarDropdown_' + x">
        <li>
          <label>
            <input @input="searchMenuItems(x, $event)" type="search" class="form-control" />
          </label>
        </li>
        <li v-for="(menuLink, i) of menu.items" :key="i">
          <router-link v-if="menuLink.link_new" class="dropdown-item" :to="menuLink.link_new">
            <span v-html="$helpers.getLocalizedField(menuLink, 'name')"></span>
          </router-link>
          <a v-else :href="oldAppLink(menuLink)" class="dropdown-item" target="_blank">
            <span v-html="$helpers.getLocalizedField(menuLink, 'name')"></span>
          </a>
        </li>
      </ul>
       <!-- Dropdown links list end -->
    </li>
    <li class="nav-item">
      <a href="https://online.ug.edu.ge/" class="nav-link" target="_blank">ძველი online.ug</a>
    </li>
  </ul>
</template>
<script>
export default {
  name: 'DropDownMenu',
  props: ['menus'],

  methods: {
    oldAppLink (navItem) {
      const appUrl = process.env.VUE_APP_OLD_URL

      return this.$helpers.appendTokenToUrl(appUrl + 'login.php?redirect=' + navItem.link)
    },

    searchMenuItems (x, $event) {
      const keyword = $event.target.value.trim()

      const menu = document.getElementById('dropdown-menu-' + x)
      if (!keyword) {
        menu.querySelectorAll('.dropdown-item').forEach(o => {
          o.className = 'dropdown-item'
        })
      } else {
        menu.querySelectorAll('.dropdown-item').forEach(o => {
          if (o.textContent.search(keyword) === -1) o.className = 'dropdown-item d-none'
          else o.className = 'dropdown-item'
        })
      }
    }
  }
}
</script>
